import * as React from 'react'
import { Box, useTheme } from '@mui/material'

export interface CaptainDetailLineProps {
  label: string
  value: string
}

/** Label + value row for expanded captain stats — Premier League fonts only */
const CaptainDetailLine: React.FC<CaptainDetailLineProps> = ({ label, value }) => {
  const theme = useTheme()
  const muted = theme.palette.text.secondary

  return (
    <Box>
      <Box
        component="span"
        sx={{
          display: 'block',
          fontFamily: 'PremierLeagueRegular',
          fontSize: '0.7rem',
          lineHeight: 1.25,
          color: muted,
        }}
      >
        {label}
      </Box>
      <Box
        component="span"
        sx={{
          display: 'block',
          fontFamily: 'PremierLeagueBold',
          fontSize: '0.8125rem',
          lineHeight: 1.35,
          color: 'text.primary',
        }}
      >
        {value}
      </Box>
    </Box>
  )
}

export default CaptainDetailLine
